import React from 'react';
import { ServicePageLayout } from '../../components/feature/service-page/ServicePageLayout';

const GooglePixelServicePage: React.FC = () => {
  return (
    <ServicePageLayout
      seo={{
        title: "Google Pixel Repair Kochi - Pixel Service Center Kerala | Device Doctor",
        description: "Professional Google Pixel repair services in Kochi, Kerala. Expert Pixel device repair for Pixel 8, 7, 6, 5 series. Screen replacement, battery repair, camera issues, software problems. Same-day service available.",
        keywords: "google pixel repair kochi, pixel service center kerala, pixel screen repair, pixel battery replacement, google pixel repair vyttila, pixel camera repair",
        structuredData: { "@context": "https://schema.org", "@type": "Service", "name": "Google Pixel Repair Services", "provider": { "@type": "LocalBusiness", "name": "Device Doctor" } }
      }}
      hero={{
        title: "Google Pixel Service Centre in Kochi",
        subtitle: "From cracked screens to battery issues, our certified technicians handle every problem with care and precision, using genuine Google Pixel parts.",
        stats: [{ value: '600+', label: 'Pixel Repairs' }, { value: '4.9★', label: 'Customer Rating' }, { value: 'Same Day', label: 'Service Available' }],
        backgroundImage: "/assets/pixel-hero-bg.jpg"
      }}
      serviceList={{
        introParagraph: "Comprehensive repair solutions for all Google Pixel models with genuine parts, certified technicians, and industry-leading warranty coverage.",
        services: [
          { id: 'display', title: 'Display & Touchscreen Repairs', icon: 'ri-smartphone-line', image: '/assets/android-repair-new.jpg', description: 'Complete screen solutions for your Google Pixel', subServices: [{ title: 'Screen Repairs', description: 'Solutions for cracked glass, flickering, liquid damage, and touch malfunctions.', features: ['Glass-only repairs', 'OLED calibration', 'Ghost touch fix', 'Backlight issues'] }] },
          { id: 'charging', title: 'Charging & Power Solutions', icon: 'ri-battery-charge-line', image: '/assets/android-repair-new.jpg', description: "Restore your Pixel's power and charging capabilities", subServices: [{ title: 'Power Solutions', description: 'Fixing slow charging, battery drain, and power IC issues.', features: ['Port replacement', 'Battery replacement', 'Wireless charging fix', 'Overheating diagnostics'] }] }
        ]
      }}
      features={{
        title: "Why Choose Device Doctor for Google Pixel Repairs",
        subtitle: "Experience the difference with our professional Google Pixel repair services.",
        badgeText: "Why Choose Us",
        items: [
          { icon: "ri-user-star-line", title: "Certified Technicians", description: "Pixel-trained experts with years of experience in Google device repairs" },
          { icon: "ri-shield-check-line", title: "Genuine Parts Only", description: "100% authentic Google Pixel components for lasting repairs" },
          { icon: "ri-time-line", title: "Same-Day Service", description: "Most screen and battery repairs completed within hours" },
          { icon: "ri-price-tag-3-line", title: "Transparent Pricing", description: "Free diagnostics with upfront, honest pricing policy" },
          { icon: 'ri-truck-line', title: 'All-Kerala Courier Services', description: 'Convenient courier pickup and delivery services available across all Kerala districts for your convenience.' },
          { icon: "ri-award-line", title: "1-Month Warranty", description: "Comprehensive warranty on all parts and labor" }
        ]
      }}
      models={{
        title: "Google Pixel Models We Service",
        subtitle: "We provide expert repair services for all Google Pixel models, from the latest flagships to classic series.",
        categories: [
          { title: 'Pixel Flagship Series', icon: 'ri-smartphone-line', models: ['Pixel 6', 'Pixel 6 Pro', 'Pixel 7', 'Pixel 7 Pro', 'Pixel 8', 'Pixel 8 Pro'], color: 'bg-blue-500' },
          { title: 'Pixel A Series', icon: 'ri-phone-line', models: ['Pixel 3a', 'Pixel 4a', 'Pixel 5a', 'Pixel 6a', 'Pixel 7a'], color: 'bg-green-500' },
          { title: 'Pixel Classic Series', icon: 'ri-smartphone-2-line', models: ['Pixel 1', 'Pixel 2', 'Pixel 3', 'Pixel 4', 'Pixel 5'], color: 'bg-purple-500' }
        ]
      }}
      testimonials={{
        items: [
          { name: "John Mathew", location: "Kochi", rating: 5, text: "I had a cracked Pixel screen and they fixed it the same day. Excellent work and great staff!", service: "Screen Replacement" },
          { name: "Sarah K.", location: "Kochi", rating: 5, text: "Battery and charging issues were sorted within hours. Fast, affordable and reliable service.", service: "Battery Replacement" }
        ]
      }}
      faq={{
        items: [
          { question: "How long will my repair take?", answer: "Most repairs (screen, battery, charging) are completed same day if booked early. Complex repairs may require 24–48 hours." },
          { question: "Are the parts genuine?", answer: "Yes, we use original Google Pixel components for long-term reliability." },
          { question: "Is there a warranty?", answer: "Every repair includes a 1-month service warranty on parts and labour." }
        ]
      }}
      cta={{
        title: "Ready to Fix Your Google Pixel?",
        subtitle: "Contact Device Doctor – Best Google Pixel Service Centre in Kochi. Call now or book online for same-day service and All-Kerala Courier Services.",
        themeColor: "blue"
      }}
    />
  );
};

export default GooglePixelServicePage;
export { GooglePixelServicePage };